<template>
  <div id="app">
    <notifications classes="toast" position="top center"/>
    <AppModal v-if="showAppBanner" />
    <router-view/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import globals from '@/globals';
import AppModal from '@/components/AppModal.vue';

export default {
  data: () => ({
    showAppBanner: false,
  }),
  metaInfo: {
    title: 'Home',
    titleTemplate: '%s | Parcelex',
    meta: [{
      vmid: 'description',
      name: 'description',
      content: 'Agora você pode parcelar suas compras sem cartão de crédito! Acesse para conferir as vantagens de utilizar a Parcelex em suas compras.',
    }],
  },
  components: {
    AppModal,
  },
  computed: {
    ...mapState('auth', ['token']),
  },
  methods: {
    ...mapActions('auth', ['setToken']),
  },
  watch: {
    $route(newValue) {
      const { onboardingToken,
        authToken,
        payWithCredit,
        downPaymentPaid,
        payWithCreditPaid,
        transactionId,
      } = newValue.query;
      if ((newValue.matched.some(({ path }) => path.startsWith('/onboarding'))
        || newValue.matched.some(({ path }) => path.startsWith('/onboarding-v2'))) && !(payWithCredit || downPaymentPaid || payWithCreditPaid)) {
        window.location.href = `${globals().onboardingUrl}/?onboardingToken=${onboardingToken || authToken}&transactionId=${transactionId}`;
      }
      const token = onboardingToken || authToken;
      if ((token && !this.token)
      || (token && this.token && token !== this.token)) this.setToken({ token });
    },
  },
};
</script>

<style lang="scss" >
@import 'scss/_colors.scss';

.tooltip {
  z-index: 10000;
}

.toast {
  margin-top: 20px;
  padding: 12px;
  color: #ffffff;
  background: #DC2626;
  border-radius: 8px;
  box-shadow: 0px 2px 4px -1px;

  .notification-content {
    display: flex;
    flex-direction: row;
    font-family: Usual;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .notification-content:before {
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='1.5' stroke='%23ffffff' class='w-6 h-6'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z' /%3E%3C/svg%3E");
    display: block;
    stroke: #ffffff;
    min-width: 24px;
    min-height: 24px;
    margin-right: 8px;
  }

  &.error {
    background: #DC2626;
  }
}
</style>
